"use client"

import { SmartphoneCharging } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SmartphoneChargingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SmartphoneChargingIcon = component(Icon)({
  as: SmartphoneCharging,
})
